import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
const { firebaseConnect } = require('react-redux-firebase');

import { RootState, Rsvp } from '../reducers/root';
import RsvpForm from '../components/forms/rsvpForm';

import './rsvp.css';

interface RsvpPageStateProps {
  rsvps: {
    [id: string]: Rsvp;
  };
}

interface RsvpPageRouterProps extends RouteComponentProps<{}> {}

interface RsvpPageProps extends RsvpPageStateProps, RsvpPageRouterProps {
  firebase: {
    push: (path: 'rsvps', data: Rsvp) => void;
  };
}

interface RsvpPageState {
  successfulSubmit: boolean;
}

const rsvpBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/rsvp_background.jpg'})`,
};

class RsvpPage extends React.PureComponent<RsvpPageProps, RsvpPageState> {
  state = {
    successfulSubmit: false,
  };

  onCreateRsvp = (rsvpData: Rsvp) => {
    this.props.firebase.push('rsvps', rsvpData);
    this.setState({ successfulSubmit: true });
  };

  render(): JSX.Element {
    if (this.state.successfulSubmit) {
      return <Redirect to="/thanks" />;
    }

    return (
      <section className="rsvp section background escape-nav" style={rsvpBackground}>
        <noscript>RSVP functionality requires javascript.</noscript>
        <div className="container">
          <div className="box">
            <h1 className="title is-shadowed has-text-centered">RSVP</h1>
            <RsvpForm onSubmit={this.onCreateRsvp} />
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state: RootState, _ownProps: RsvpPageRouterProps): RsvpPageStateProps {
  return {
    rsvps: state.firebase.data.rsvps,
  };
}

export default connect(mapStateToProps)(firebaseConnect(['rsvps'])(RsvpPage));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/rsvp.tsx